/* ============================================================
 * Jinny Joes — Newsletter Popup
 *
 * Oeffnen/Schliessen, Verzoegerung und "nur einmal zeigen"
 * werden bereits vom Theme selbst uebernommen
 * (js/components/NewsletterPopup.js + PopupsSection in
 * theme.js), sobald das Element data-popup-type="newsletter"
 * traegt. Dieses Skript uebernimmt zwei Dinge:
 *
 *   A) Absenden des Formulars — analog zu jj-notify-me.js
 *      fuer das Back-in-Stock-Modal:
 *      1. Shopify legt den Kunden ueber das native 'customer'-
 *         Formular an — per fetch, OHNE Seiten-Reload.
 *      2. Parallel wird die Adresse ueber die Klaviyo Client-API
 *         an der zur Sprache passenden Liste angemeldet
 *         (Double-Opt-in -> bestehender Welcome-Flow mit
 *         5-CHF-Gutschein, wie im Footer-Newsletter V8.1).
 *
 *   B) Zuruecksetzen des Merkers "themePopup" im Customizer.
 *      Das Theme schreibt diesen localStorage-Merker in
 *      NewsletterPopup._openPopup() — und zwar AUCH dann, wenn
 *      das Popup nur durch Anklicken des Blocks im Theme-Editor
 *      aufgeht (PopupsSection.onBlockSelect ruft dieselbe
 *      Methode auf). Danach gilt der eigene Browser als
 *      "hat es schon gesehen" und das Popup bleibt in der
 *      Vorschau aus, solange "nur einmal zeigen" aktiv ist.
 *      Im Design-Modus wird der Merker deshalb wieder entfernt.
 *      Fuer echte Besucher aendert sich nichts.
 *
 * Alle Konfiguration (Public Key, Listen-IDs, Locale) kommt
 * aus dem data-popup-settings JSON, das die Section bereits
 * fuer die Theme-eigene Popup-Klasse rendert.
 * ============================================================ */

(function () {
  'use strict';

  var API_REVISION = '2024-10-15';
  var SUBSCRIBE_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var STORAGE_KEY = 'themePopup';
  var DEBUG = /[?&]jjdebug=1\b/.test(window.location.search);
  var IS_DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[jj-newsletter-popup]');
    console.log.apply(console, args);
  }

  // Siehe Punkt B im Kopfkommentar: nur im Theme-Editor aktiv.
  function clearPopupFlagInDesignMode() {
    if (!IS_DESIGN_MODE) { return; }
    try {
      if (localStorage.getItem(STORAGE_KEY) !== null) {
        localStorage.removeItem(STORAGE_KEY);
        log('Merker "' + STORAGE_KEY + '" im Customizer zurueckgesetzt.');
      }
    } catch (e) {
      // localStorage kann in strengen Datenschutz-Modi werfen — unkritisch.
    }
  }

  function readSettings(popup) {
    try {
      return JSON.parse(popup.getAttribute('data-popup-settings')) || {};
    } catch (e) {
      return {};
    }
  }

  function setLoading(form, isLoading) {
    var btn = form.querySelector('.jj-popup-newsletter__button');
    var label = form.querySelector('.jj-popup-newsletter__button-label');
    var loading = form.querySelector('.jj-popup-newsletter__button-loading');
    if (btn) { btn.disabled = isLoading; }
    if (label) { label.hidden = isLoading; }
    if (loading) { loading.hidden = !isLoading; }
  }

  function showSuccess(popup) {
    var formPanel = popup.querySelector('[data-state="form"]');
    var successPanel = popup.querySelector('[data-state="success"]');
    if (formPanel) { formPanel.hidden = true; }
    if (successPanel) { successPanel.hidden = false; }
  }

  function focusFirstField(popup) {
    setTimeout(function () {
      var field = popup.querySelector('[data-state="form"]:not([hidden]) input');
      if (field) { field.focus(); }
    }, 200);
  }

  function subscribeToKlaviyo(publicKey, listId, email, firstName) {
    if (!publicKey || !listId) {
      log('Klaviyo-Anmeldung uebersprungen (kein Public Key oder keine Listen-ID).');
      return Promise.resolve();
    }

    var profileAttributes = { email: email };
    if (firstName) { profileAttributes.first_name = firstName; }

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter Popup (Webseite)',
          profile: { data: { type: 'profile', attributes: profileAttributes } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    return fetch(SUBSCRIBE_URL + encodeURIComponent(publicKey), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': API_REVISION },
      body: JSON.stringify(payload)
    }).catch(function (err) {
      log('Klaviyo-Anmeldung fehlgeschlagen (nicht blockierend):', err);
    });
  }

  function createShopifyCustomer(form) {
    return fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Accept': 'text/html' }
    }).catch(function (err) {
      log('Shopify-Formular fehlgeschlagen (nicht blockierend):', err);
    });
  }

  function handleSubmit(popup, form, settings) {
    var emailField = form.querySelector('input[type="email"]');
    var nameField = form.querySelector('input[name="contact[first_name]"]');
    var email = emailField && emailField.value ? emailField.value.trim() : '';
    var firstName = nameField && nameField.value ? nameField.value.trim() : '';

    var lists = settings.klaviyoLists || {};
    var locale = (settings.locale || 'de').toLowerCase().slice(0, 2);
    var listId = lists[locale] || lists.de;

    log('Submit: email=', email, 'firstName=', firstName, 'locale=', locale, 'listId=', listId);

    setLoading(form, true);

    var shopifySignup = createShopifyCustomer(form);
    var klaviyoSignup = subscribeToKlaviyo(settings.klaviyoPublicKey, listId, email, firstName);

    Promise.all([shopifySignup, klaviyoSignup]).then(function () {
      setLoading(form, false);
      showSuccess(popup);
    });
  }

  function initPopup(popup) {
    var form = popup.querySelector('.jj-popup-newsletter__form');
    if (!form) { return; }

    var settings = readSettings(popup);

    form.addEventListener('submit', function (e) {
      // Native HTML5-Validierung zuerst greifen lassen (leeres/
      // ungueltiges E-Mail-Feld zeigt die Browser-eigene Meldung).
      if (!form.checkValidity()) {
        if (form.reportValidity) { form.reportValidity(); }
        return;
      }
      e.preventDefault();
      handleSubmit(popup, form, settings);
    });

    // Reagiert darauf, dass das Theme das Popup oeffnet
    // (aria-hidden="false", siehe NewsletterPopup._openPopup()):
    //   - erstes Feld fokussieren
    //   - im Customizer den soeben gesetzten Merker wieder loeschen
    // Der MutationObserver laeuft nach dem synchronen Block in
    // _openPopup(), also verlaesslich NACH dem localStorage-Schreiben.
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'aria-hidden' && popup.getAttribute('aria-hidden') === 'false') {
          focusFirstField(popup);
          clearPopupFlagInDesignMode();
        }
      });
    });
    observer.observe(popup, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    // Merker aus einer frueheren Customizer-Sitzung aufraeumen.
    clearPopupFlagInDesignMode();
    document.querySelectorAll('.jj-popup-newsletter[data-popup-type="newsletter"]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
